// === opens a collapse from a url
location.hash && $(location.hash + '.collapse').collapse('show');

// push page content down so dropdown menu does not cover ads
$('li.dropdown.dd_categories').on({
			"shown.bs.dropdown": function() { this.closable = false; 
$('.menu_category').css('margin-top', '160px'); },
			"click": function() { this.closable = true; 
$('.menu_category').css('margin-top', '0px');},
			"hide.bs.dropdown": function() { return this.closable; 
$('.menu_category').css('margin-top', '0px');}
});
$('li.dropdown.dd_quizzes').on({
			"shown.bs.dropdown": function() { this.closable = false; 
$('.menu_category').css('margin-top', '112px'); },
			"click": function() { this.closable = true; 
$('.menu_category').css('margin-top', '0px');},
			"hide.bs.dropdown": function() { return this.closable; 
$('.menu_category').css('margin-top', '0px');}
});
(function(){
	$.subscribe('form.submitted', function(){
		$('.flash').fadeIn(500).delay(3000).fadeOut(500);
	});
})();

function voteUpdate(obj)
{
	var vote = obj.getAttribute('data-voted');
	var id = obj.getAttribute('data-id');
	if (vote == 'up'){
	  	$('#votes_up_'+id).css('color', '#EF8D24');
		$('#votes_dn_'+id).css('color', '#FFFFFF');
		$('#votes_up_'+id+' input[type=button]').button('disable');
		$('#votes_dn_'+id+' input[type=button]').button('enable');
	}
	if (vote == 'down'){
		$('#votes_up_'+id).css('color', '#FFFFFF');
		$('#votes_dn_'+id).css('color', '#EF8D24');
		$('#votes_up_'+id+' input[type=button]').button('enable');
		$('#votes_dn_'+id+' input[type=button]').button('disable');
	}
   $('#voteCount'+id).attr("votes", obj.getAttribute('data-value'));
}
function surveyUpdate(obj)
{
	var vote = obj.getAttribute('data-voted');
	var id = obj.getAttribute('data-id');
	var data_voted = obj.getAttribute('data-value');
	var data_voted2 = obj.getAttribute('data-value2');
	if (vote == 'up'){
	  	$('#survey_yes_'+id).css('color', '#EF8D24');
		$('#survey_no_'+id).css('color', '#FFFFFF');
		$('#survey_yes_'+id).prop('disabled', false);
		$('#survey_no_'+id).prop('disabled', false);
		$('#votesUp'+id).attr("data-votes", data_voted);
		$('#votesDn'+id).attr("data-votes", data_voted2);
	}
	if (vote == 'down'){
		$('#survey_yes_'+id).css('color', '#FFFFFF');
		$('#survey_no_'+id).css('color', '#EF8D24');
		$('#survey_yes_'+id).prop('disabled', false);
		$('#survey_no_'+id).prop('disabled', false);
		$('#votesDn'+id).attr("data-votes", data_voted);
		$('#votesUp'+id).attr("data-votes", data_voted2);
	}
}

function popup(url) 
{
 var width  = 626;
 var height = 434;
 var left   = (screen.width  - width)/2;
 var top    = (screen.height - height)/2;
 var params = 'width='+width+', height='+height;
 params += ', top='+top+', left='+left;
 params += ', directories=no';
 params += ', location=no';
 params += ', menubar=no';
 params += ', resizable=no';
 params += ', scrollbars=no';
 params += ', status=no';
 params += ', toolbar=no';
 newwin=window.open(url,'windowname5', params);
 if (window.focus) {newwin.focus()}
 return false;
}